/*
import React, {useEffect, useState} from 'react'
import './InfoPanel.css'
import './GuidePanel.css'
import {useAppStore} from '../stores/store.js'
import {gsap} from 'gsap'

export function InfoPanel({data, onClose, onResetCamera}) {

    // const [isVisible, setIsVisible] = useState(false)
    const openTabletAction = useAppStore((state) => state.openTablet)

    const {
        id,
        title = 'Info',
        description = 'No details available.',
        link, // Optional link
        linkText = 'More Info',
    } = data

    function handleClosePanel() {
        let target = '.info-panel'
        if (id === 'info') target = '.guide-panel'
        const timeline = gsap.timeline({
            defaults: {duration: 0.6, ease: 'power4.out'},
        })
        timeline.to(target, {opacity: 1, scale: 1, pointerEvents: 'auto'}, 0)
    }

    function handleOpenPanel(id) {
        let target = '.info-panel'
        if (id === 'info') target = '.guide-panel'
        const timeline = gsap.timeline({
            defaults: {duration: 0.6, ease: 'power4.out'},
        })
        timeline.to(target, {opacity: 1, scale: 1, pointerEvents: 'auto'}, 0)
    }


    useEffect(() => {
        handleOpenPanel(data.id)
    }, [])

    const handleClick = (e) => {
        e.stopPropagation()
    }

    const handleLinkClick = (e) => {
        e.stopPropagation()
    }

    const handleResetClick = (e) => {
        e.stopPropagation()
        if (onResetCamera) onResetCamera()
        onClose()

        handleClosePanel()
    }

    const handleMusicClick = (e) => {
        e.stopPropagation()
        if (onResetCamera) onResetCamera()
        onClose()

        openTabletAction()
    }

    const GuideInfo = () => {
        const [currentPage, setCurrentPage] = useState(1);
        const pageNumber = 2

        const handlePreviousNextClick = (e) => {
            e.stopPropagation()
            setCurrentPage(currentPage === 1 ? 2 : 1)
        }

        const pageContent = () => {
            switch (currentPage) {
                case 1:
                    return (
                        <div className='guide-panel-description'>
                            <div className='guide-panel-cols'>
                                <div className='three-images-container'>
                                    <img className='three-images' src='./images/left-mouse.svg' alt='Info Panel Image'/>
                                    <p>Left click to look around</p>
                                </div>
                                <div className='three-images-container'>
                                    <img className='three-images' src='./images/right-mouse.svg'
                                         alt='Info Panel Image'/>
                                    <p>Right click to move around</p>
                                </div>
                                <div className='three-images-container'>
                                    <img className='three-images' src='./images/middle-mouse.svg'
                                         alt='Info Panel Image'/>
                                    <p>Middle mouse to zoom in and out</p>
                                </div>
                                {/!*<div><img src='./images/right-mouse.svg' alt='Info Panel Image'/></div>*!/}
                                {/!*<div><img src='./images/middle-mouse.svg' alt='Info Panel Image'/></div>*!/}

                            </div>
                            <h2>How to navigate</h2>
                        </div>
                    );
                case 2:
                    return (
                        <div className='guide-panel-description'>
                            <div className='guide-panel-image'>
                                <img src='./images/guide-1.webp' alt='Info Panel Image'/>

                            </div>
                            <h2>Interactivity</h2>
                            <p>Outlined objects are interactive and can be clicked on.</p>
                        </div>
                    );
                default:
                    return <p>Page not found.</p>;
            }
        };

        return (
            <>

                {/!*<img src='./images/middle-mouse.svg' alt='Info Panel Image'/>*!/}
                {/!*<p>{description}</p>*!/}
                <div className='guide-panel' onClick={handleClick}>
                    <div className='guide-panel-top'>
                        <h3 className='guide-panel-title'>{title}</h3>
                        <button className='info-panel-close' onClick={onClose} aria-label='Close'></button>
                    </div>

                    <div className='guide-panel-middle'>
                        {/!*<img src='./images/guide-1.webp' alt='Info Panel Image'/>*!/}
                        {/!*<p>{description}</p>*!/}
                        {pageContent()}

                    </div>

                    <div className='guide-panel-bottom'>
                        {currentPage === 2 ? (
                            <button
                                className='info-panel-button prev'
                                onClick={handlePreviousNextClick}
                            >
                                Previous
                            </button>
                        ) : (
                            <div className="button-placeholder prev-placeholder"></div>
                        )}
                        <div className="page-dots-container">
                            {[...Array(pageNumber)].map((_, index) => (
                                <span
                                    key={index}
                                    className={`page-dot ${currentPage === index + 1 ? 'active' : ''}`}
                                ></span>
                            ))}
                        </div>
                        {currentPage === 1 ? (
                            <button
                                className='info-panel-button next'
                                onClick={handlePreviousNextClick}
                            >
                                Next
                            </button>
                        ) : (
                            <div className="button-placeholder next-placeholder"></div>
                        )}
                    </div>
                </div>
            </>)
    }


    return (
        <>
            {id === 'info' ? <GuideInfo/> :
                <div className='info-panel' onClick={handleClick}>
                    <div className='info-panel-top'>
                        <h3 className='info-panel-title'>{title}</h3>
                        <button className='info-panel-close' onClick={onClose} aria-label='Close'></button>
                    </div>

                    <div className='info-panel-middle'>
                        {id === 'trophy' ? (
                            <p> Made by the brilliant <a
                                className='info-panel-link'
                                href='https://bruno-simon.com'
                                target='_blank'
                                rel='noopener noreferrer'
                                onClick={handleLinkClick}>Bruno Simon</a>
                                {description}
                            </p>
                        ) : <p>{description}</p>
                        }
                    </div>
                    <div className='info-panel-bottom'>

                        {link && (
                            <a className='info-panel-button'
                               href={link}
                               target='_blank'
                               rel='noopener noreferrer'
                               onClick={handleLinkClick}
                            >
                                {linkText}
                            </a>
                        )}
                        {onResetCamera && (
                            <>
                                {id === 'tablet' && (
                                    <button className='info-panel-button' onClick={handleMusicClick}>
                                        Play Music
                                    </button>
                                )}
                                <button className='info-panel-button' onClick={handleResetClick}>
                                    Go back
                                </button>
                            </>
                        )}
                    </div>
                </div>
            }
        </>
    )
}



*/


import React, {useEffect, useState, useRef} from 'react'; // Added useRef
import './InfoPanel.css';
import './GuidePanel.css';
import {useAppStore} from '../stores/store.js';
import {gsap} from 'gsap';
import {useGameStore} from '../stores/gameStore.js'

export function InfoPanel({data, onClose, onResetCamera}) {
    const panelRef = useRef(null); // Ref for the main panel element
    const openTabletAction = useAppStore((state) => state.openTablet);
    const startGame = useGameStore((state) => state.startGame);

    const {
        id,
        title = 'Info',
        description = 'No details available.',
        link,
        linkText = 'More Info',
    } = data;

    // Determine the correct CSS class based on the id
    const panelClassName = id === 'info' || id === 'credits' ? 'guide-panel' : 'info-panel';

    // Animation functions - now they operate on the ref
    const animateOpen = (targetElement) => {
        if (targetElement) {
            gsap.to(targetElement, {
                opacity: 1,
                scale: 1,
                pointerEvents: 'auto',
                duration: 0.4, // Slightly faster for responsiveness
                ease: 'power2.out',
            });
        }
    };

    const animateClose = (targetElement, callback) => {
        if (targetElement) {
            gsap.to(targetElement, {
                opacity: 0,
                scale: 0.85,
                pointerEvents: 'none',
                duration: 0.3,
                ease: 'power2.in',
                onComplete: callback, // Call the callback (onClose) after animation
            });
        } else if (callback) {
            callback(); // If no element, just call callback
        }
    };

    // Effect to handle opening animation when 'data' (and thus 'id') changes
    useEffect(() => {
        // Ensure the panel is initially set to its "closed" state via CSS
        // or reset it here before animating open if necessary.
        // For simplicity, assuming CSS handles initial closed state (opacity: 0, scale: 0.85, pointer-events: none)
        if (panelRef.current) {
            // Immediately set to closed state before animating open,
            // especially important if switching panel types.
            gsap.set(panelRef.current, {opacity: 0, scale: 0.85, pointerEvents: 'none'});
            animateOpen(panelRef.current);
        }
    }, [data]); // Rerun when data (which includes id) changes

    const handleClick = (e) => {
        e.stopPropagation();
    };

    const handleLinkClick = (e) => {
        e.stopPropagation();
    };

    const handleActualClose = () => {
        // This function will be called by onResetCamera or directly by onClose prop
        animateClose(panelRef.current, onClose);
    };


    const handleResetClick = (e) => {
        e.stopPropagation();
        if (onResetCamera) onResetCamera(); // This might trigger camera movement
        handleActualClose(); // Then animate close and call the original onClose
    };

    const handleMusicClick = (e) => {
        e.stopPropagation();
        // No need to call onResetCamera if it just opens tablet,
        // unless opening tablet should also reset camera.
        if (onResetCamera) onResetCamera();
        openTabletAction();
        handleActualClose(); // Close the panel after opening tablet
    };

    const handlePlayTargetClick = (e) => {
        e.stopPropagation();
        if (onResetCamera) onResetCamera()
        handleActualClose()
        startGame()
    }

    // --- GuideInfo Sub-Component ---
    const GuideInfo = () => {
        const [currentPage, setCurrentPage] = useState(1);
        const totalPages = 2; // Renamed from pageNumber for clarity

        const handlePageNavigation = (direction) => {
            if (direction === 'next' && currentPage < totalPages) {
                setCurrentPage(currentPage + 1);
            } else if (direction === 'prev' && currentPage > 1) {
                setCurrentPage(currentPage - 1);
            }
        };
        // Or your existing simpler toggle for 2 pages:
        // const handlePreviousNextClick = (e) => {
        //     e.stopPropagation();
        //     setCurrentPage(currentPage === 1 ? 2 : 1);
        // };


        const pageContent = () => {
            switch (currentPage) {
                case 1:
                    return (
                        <div className='guide-panel-description'>
                            <div className='guide-panel-cols'>
                                <div className='three-images-container'>
                                    <img className='three-images' src='./images/left-mouse.svg' alt='Left Click'/>
                                    <p>Left click to look around</p>
                                </div>
                                <div className='three-images-container'>
                                    <img className='three-images' src='./images/right-mouse.svg' alt='Right Click'/>
                                    <p>Right click to move around</p>
                                </div>
                                <div className='three-images-container'>
                                    <img className='three-images' src='./images/middle-mouse.svg' alt='Middle Mouse'/>
                                    <p>Middle mouse to zoom in and out</p>
                                </div>
                            </div>
                            <h2>How to navigate</h2>
                        </div>
                    );
                case 2:
                    return (
                        <div className='guide-panel-description'>
                            <div className='guide-panel-image'>
                                <img src='./images/guide-1.webp' alt='Interactive Objects'/>
                            </div>
                            <h2>Interactivity</h2>
                            <p>Outlined objects are interactive and can be clicked on.</p>
                        </div>
                    );
                default:
                    return <p>Page not found.</p>;
            }
        };

        return (
            // The ref is on the root element of what this component renders
            <div ref={panelRef} className={panelClassName} onClick={handleClick}
                 style={{opacity: 0, transform: 'scale(0.85)', pointerEvents: 'none'}}> {/* Initial styles for GSAP */}
                <div className='guide-panel-top'>
                    <h3 className='guide-panel-title'>{title}</h3> {/* Show page for guide */}
                    <button className='info-panel-close' onClick={handleActualClose} aria-label='Close'></button>
                </div>
                <div className='guide-panel-middle'>
                    {pageContent()}
                </div>
                <div className='guide-panel-bottom'>
                    {currentPage > 1 ? (
                        <button className='info-panel-button prev' onClick={() => handlePageNavigation('prev')}>
                            Previous
                        </button>
                    ) : <div className="button-placeholder prev-placeholder"></div>}

                    <div className="page-dots-container">
                        {[...Array(totalPages)].map((_, index) => (
                            <span
                                key={index}
                                className={`page-dot ${currentPage === index + 1 ? 'active' : ''}`}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setCurrentPage(index + 1);
                                }}
                            ></span>
                        ))}
                    </div>

                    {currentPage < totalPages ? (
                        <button className='info-panel-button next' onClick={() => handlePageNavigation('next')}>
                            Next
                        </button>
                    ) : <div className="button-placeholder next-placeholder"></div>}
                </div>
            </div>
        );
    };

    const Credits = () => {
        return (
            <div ref={panelRef} className={panelClassName} onClick={handleClick}>
                <div className='guide-panel-top'>
                    <h3 className='guide-panel-title'>{title}</h3>
                    <button className='info-panel-close' onClick={handleActualClose} aria-label='Close'></button>
                </div>
                <div className='guide-panel-middle'>
                    <ul>
                        <li>Jhin and Sivir model taken from modelviewer.lol, copyright Riot Games</li>
                        <li>Luigi model from mario kart tour copyright Nintendo</li>
                        <li>Font HarmonyOS from Hwawei</li>
                        <li>StrawberryJamCroissant favicon from @nimasain on twitter</li>
                    </ul>
                </div>
                <div className='guide-panel-bottom'></div>
            </div>
        )
    }

    // --- Main Return for InfoPanel ---
    if (id === 'info') {
        return <GuideInfo/>; // Props like title, onClose, handleClick are implicitly available via closure
    }

    if (id === 'credits') {
        return <Credits/>
    }

    return (
        // The ref is on the root element of what this component renders
        <div ref={panelRef} className={panelClassName} onClick={handleClick}
             style={{opacity: 0, transform: 'scale(0.85)', pointerEvents: 'none'}}> {/* Initial styles for GSAP */}
            <div className='info-panel-top'>
                <h3 className='info-panel-title'>{title}</h3>
                <button className='info-panel-close' onClick={handleActualClose} aria-label='Close'></button>
            </div>
            <div className='info-panel-middle'>
                {id === 'trophy' ? (
                    <p> Made by the brilliant <a
                        className='info-panel-link' href='https://bruno-simon.com'
                        target='_blank' rel='noopener noreferrer' onClick={handleLinkClick}>Bruno Simon</a>
                        {description}
                    </p>
                ) : <p>{description}</p>
                }
            </div>
            <div className='info-panel-bottom'>
                {link && (
                    <a className='info-panel-button' href={link}
                       target='_blank' rel='noopener noreferrer' onClick={handleLinkClick}>
                        {linkText}
                    </a>
                )}
                {onResetCamera && (
                    <>
                        {id === 'tablet' && (
                            <button className='info-panel-button' onClick={handleMusicClick}>
                                Play Music
                            </button>
                        )}
                        {id === 'target' && (
                            <button className='info-panel-button' onClick={handlePlayTargetClick}>
                                Play!
                            </button>
                        )}
                        <button className='info-panel-button' onClick={handleResetClick}>
                            Go back
                        </button>
                    </>
                )}
            </div>
        </div>
    );
}